import React, { createContext, useContext, useState } from "react";
import BookDemoModal from "../components/BookDemoModal";

const BookDemoContext = createContext();

export const useBookDemo = () => useContext(BookDemoContext);

export const BookDemoProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openBookDemo = (e) => {
    if (e) e.preventDefault();
    setIsOpen(true);
  };

  const closeBookDemo = () => setIsOpen(false);

  return (
    <BookDemoContext.Provider value={{ openBookDemo, closeBookDemo }}>
      {children}
      <BookDemoModal isOpen={isOpen} onClose={closeBookDemo} />
    </BookDemoContext.Provider>
  );
};
